import { cityMap } from './Cities';
import standardSections from './Standard-City';

const sections = standardSections("dash09.la@gmail.com",
  "The hunt will take place starting at <strong>Sumac Park, 6000 Calmfield Ave, in Agoura Hills.</strong> " +
  "Meet at the southwest corner of the park near the parking lot. " +
  "<strong><i>Note</i></strong>: This is a change form the earlier starting location in <strike>Chumash Park</strike>. ");

cityMap['los-angeles'].sections = sections;
cityMap['los-angeles'].eventStartLocation =
    "Sumac Park, 6000 Calmfield Ave, in Agoura Hills. " +
    "<stong><i>Note</i></stong>: This is a change from the earlier location in <strike>Chumash Park</strike>.";
    /*
    "The hunt will take place starting at Chumash Park (5550 Medea Valley Drive) in Agoura Hills. " +
    "Walk across the park past the bathrooms and playground. Meet at the large " +
    "tree below the rocks on the far side of the park";
    */




// WEBPACK FOOTER //
// ./src/cities/Los-Angeles.js